import { z } from "zod"

export const SendMessageAsCustomerSchema = z.object({
  jobId: z.guid(),
  content: z.string().min(1),
  // attachedFiles handled by multer, not in validation
})

export type SendMessageAsCustomer = z.infer<
  typeof SendMessageAsCustomerSchema
> & {
  attachedFiles?: File[]
}
